import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import ptBR from 'vee-validate/dist/locale/pt_BR';
import { expirationDate, number as creditCardNumber } from 'card-validator';

import Errors from '@/shared/translate/errors';

import { validateCPF } from '@/helpers/Validation/document';
import {
  validatePhoneNumber,
  validateUsername,
  validatePassword,
  validateBirthDate,
} from '@/helpers/Validation/general';

import { userExists, verifyEmail } from '@/api/resources/customer';

const brands = [
  'amex',
  'american_express',
  'american-express',
  'elo',
  'visa',
  'mastercard',
  'maestro',
  'hipercard',
  'hiper',
];

Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid',
  },
  events: 'blur',
  mode: 'eager',
});

Validator.localize('pt_BR', ptBR);
Validator.localize({
  pt_BR: {
    custom: {
      ...Errors.pt_BR.Fields,
    },
  },
});

Validator.extend('cpf', value => validateCPF(value));
Validator.extend('username', value => validateUsername(value));
Validator.extend('password', value => validatePassword(value));

Validator.extend('isCardExpiryDateValid', (value) => {
  return expirationDate(value, 15).isValid;
});

Validator.extend('isCardNumberValid', (value) => {
  const creditCard = creditCardNumber(value);
  return creditCard.isValid && !!creditCard.card && brands.includes(creditCard.card!.type);
});

Validator.extend('userExists', async (username: string) => {
  try {
    await userExists(username);

    return true;
  } catch {
    return false;
  }
});

Validator.extend('userNotExists', async (username: string) => {
  try {
    await userExists(username);
    return false;
  } catch {
    return true;
  }
});

Validator.extend('verifyEmail', async (email: string) => {
  try {
    const validEmail = await verifyEmail(email);
    return validEmail.data.valid;
  } catch {
    return false;
  }
});

Validator.extend('phoneStartsWithNine', validatePhoneNumber);
Validator.extend('isOverEighteenYearsOld', validateBirthDate);

Validator.extend('minValueAmountToPay', async (amount: any) => {
  return amount > 1.99;
});
